<template>
    <div>
        <toggle-payer-modal v-if="showModal"
                            :order="order"
                            @confirm="onPayerToggle"
                            @cancel="showModal = false"></toggle-payer-modal>

        <div>
            {{ order.decoded_payer }}
        </div>

        <div v-if="payerIsEditable">
            <button class="btn btn-sm" @click="showModal = true">Modifier</button>
        </div>
    </div>
</template>

<script type="text/babel">
    import { mapState, mapActions, mapGetters } from 'vuex'
    import TogglePayerModal from './TogglePayerModal'

    export default {
        components: {
            TogglePayerModal
        },

        data () {
            return {
                showModal: false,
            }
        },

        props: ['order'],

        computed: {
            payerIsEditable() {
                return this.order.customer.intermediary_business_id != null 
                    && this.order.intermediary_business_id != null 
                    && this.order.customer.intermediary_business_id == this.order.intermediary_business_id
                    && 'pending' == this.order.payment_status
            },
        },

        methods: {
            ...mapActions("customer", ['fetchOrders']),

            onPayerToggle() {
                this.axios.put(`orders/${this.order.id}/toggle_payer`)
                .then((response) => {
                    this.fetchOrders()
                    this.showModal = false
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// client/components/Customer/OrdersTabContent/OrderPayer.vue